import { render, staticRenderFns } from "./DraggableContainer.vue?vue&type=template&id=3ddc0180&scoped=true&"
import script from "./DraggableContainer.vue?vue&type=script&lang=ts&"
export * from "./DraggableContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableContainer.vue?vue&type=style&index=0&id=3ddc0180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc0180",
  null
  
)

export default component.exports